import React,{ Component} from 'react'
import { Redirect } from 'react-router'
class ReloaderEntrada extends Component {

    render(){
        return(<Redirect push to={{pathname:"/restaured.admin/monitoreo",state:this.props.location.state}}> </Redirect>)
    }
}
 export default ReloaderEntrada